import { render, staticRenderFns } from "./DocumentEditView.vue?vue&type=template&id=b2a0d720&scoped=true&"
import script from "./DocumentEditView.vue?vue&type=script&lang=ts&"
export * from "./DocumentEditView.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentEditView.vue?vue&type=style&index=0&id=b2a0d720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a0d720",
  null
  
)

export default component.exports